import React from 'react';

const ScobyIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Outer ring */}
    <circle cx="12" cy="12" r="9" fill="none" stroke="#000000" strokeWidth="2" />
    {/* Center dot */}
    <circle cx="12" cy="12" r="3.5" fill="#000000" />
  </svg>
);

export default ScobyIcon;
